/*
 * @Date: 2022-08-15 14:30:56
 * @LastEditTime: 2022-08-16 10:10:00
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_DisplayBopAccountManageScreen = (...params) =>
  net_common.post("/api/STDSDC02C06/DisplayBopAccountManageScreen", ...params);

export const API_UpdateBopAccount = (...params) =>
  net_common.post("/api/STDSDC02C06/UpdateBopAccount", ...params);

export const API_DeleteBopUser = (...params) =>
  net_common.post("/api/STDSDC02C06/DeleteBopUser", ...params);

export const API_GetBopAccountList = (...params) =>
  net_common.post("/api/STDSDC02C06/GetBopAccountList", ...params);

export const API_SendBopAccountNotification = (...params) =>
  net_common.post("/api/STDSDC02C06/SendBopAccountNotification", ...params);